import axios from 'axios';

import { AuthTokenResponse } from 'app/api/model/AuthTokenResponse';
import { config } from 'app/config/config';

class AuthenticationService {
    public readonly fetchAccessToken = (code: string, codeVerifier: string): Promise<AuthTokenResponse> =>
        axios
            .post(
                config.AUTH_TOKEN_URL,
                {
                    grant_type: 'authorization_code',
                    redirect_uri: config.AUTH_CALLBACK_URL,
                    code_verifier: codeVerifier,
                    code,
                },
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    auth: {
                        username: config.AUTH_CLIENT_ID,
                        password: '',
                    },
                },
            )
            .then((response) => response.data);
}

const authenticationService = new AuthenticationService();

export { authenticationService };
